import { useMutation } from '@apollo/client';
import { graphql } from '../graphql';
export const SEND_SECURE_FORM_TOKEN = graphql(`
  mutation sendSecureFormToken(
    $id: String!
    $invitationId: String!
    $token: String!
    $timestamp: String!
  ) {
    sendSecureFormToken(
      input: {
        id: $id
        invitationId: $invitationId
        token: $token
        timestamp: $timestamp
      }
    )
  }
`);
export const useSendSecureFormToken = () => {
    const [sendSecureFormToken] = useMutation(SEND_SECURE_FORM_TOKEN);
    return ({ token, invitationId, timestamp, id, }) => sendSecureFormToken({
        variables: {
            id,
            invitationId,
            token,
            timestamp,
        },
    }).then(response => { var _a; return (_a = response.data) === null || _a === void 0 ? void 0 : _a.sendSecureFormToken; });
};
//# sourceMappingURL=useSendSecureFormToken.js.map